import { Link } from "react-router-dom";
import DocNavigation from "../../components/DocNavigation";

export default function DataMigration() {
  return (
    <section className="space-y-10">

      {/* HEADER */}
      <section className="bg-white rounded-xl border border-slate-200 p-10">
        <h1 className="text-2xl font-bold text-slate-900 mb-2">
          Data Migration
        </h1>

        <p className="text-md text-slate-600 max-w-3xl">
          Data migration ensures that your historical data is safely transferred
          into EventFlow without loss or inconsistency.
        </p>

        <section className="bg-white border-l border-[#C9A24E] p-4 mt-4">
          <h2 className="text-lg font-semibold mb-2">Overview</h2>
          <p className="text-sm text-slate-600">
            Migration preserves continuity when moving from legacy systems.
          </p>
        </section>
      </section>

      {/* WHY */}
      <section className="bg-slate-100 rounded-xl p-10">
        <h2 className="text-xl font-semibold mb-3">
          Why Data Migration Is Critical
        </h2>

        <p className="text-md text-slate-600 max-w-3xl mb-4">
          Accurate historical data is essential for reporting, audits, and
          business decision-making.
        </p>

        <ul className="list-disc pl-5 text-slate-600 space-y-2">
          <li>Preserves booking history</li>
          <li>Maintains financial balances</li>
          <li>Ensures reporting continuity</li>
          <li>Reduces operational risk</li>
        </ul>
      </section>

      {/* DATA TYPES */}
      <section className="bg-white border border-slate-200 rounded-xl p-10">
        <h2 className="text-xl font-semibold mb-4">
          Data That Can Be Migrated
        </h2>

        <ul className="list-disc pl-5 text-slate-600 space-y-2">
          <li>Customers & bookings</li>
          <li>Financial transactions</li>
          <li>Suppliers & purchases</li>
          <li>Opening balances & accounts</li>
          <li>Reports & historical summaries</li>
        </ul>
      </section>

      {/* PROCESS */}
      <section className="bg-slate-100 rounded-xl p-10">
        <h2 className="text-xl font-semibold mb-3">
          Migration Process
        </h2>

        <ol className="list-decimal pl-5 text-slate-600 space-y-2">
          <li>Data review & cleanup</li>
          <li>Field mapping</li>
          <li>Test migration</li>
          <li>Validation & reconciliation</li>
          <li>Final production migration</li>
        </ol>
      </section>
{/* 
      <section className="border-t pt-8 mt-12">
                <p className="text-slate-600">
                    Next, learn about{" "}
                    <Link to="/docs/about" className="font-medium text-[#C9A24E]">
                       About Us
                    </Link>.
                </p>
            </section> */}
      <DocNavigation
        previous={{
          title: "Integration",
          link: "/docs/integration"
        }}
        next={{
          title: "About Us",
          link: "/docs/about"
        }}
      />

    </section>
  );
}
